import HasFormState from "@/store/base/hasForm/state"

export default Object.assign(HasFormState,{
  formData: {
    receivers: [],
    module: '',
    message: '',
  },
})